var router = require('pjax').Router;
var form = require('./form.js').default;
var profile = require('./profile.js');
var index = require('./index.js');
var imports = require('./imports.js');

router.get('user/import', imports);
router.get('user/:any', form);
router.get('users/:any', form);
router.get('user', index);
router.get('profile', profile);
router.get('profile/complete', profile);
router.get('profile/complete/:any', profile);
